import {
  AngularFirestore,
  AngularFirestoreCollection
} from "@angular/fire/firestore";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "../models/user";
import { HttpClient, HttpParams } from "@angular/common/http";
export class UserApi {
  public collection: AngularFirestoreCollection<User>;
  constructor(public db: AngularFirestore, public httpClient: HttpClient) {
    this.collection = this.db.collection("devUsers");
  }

  getAuthorizedUsers(): Observable<User[]> {
    return this.db
      .collection<User>("devUsers", ref =>
        ref
          .where("admin.type", "in", [
            "VenueRead",
            "LineLeapRead",
            "VenueAdmin",
            "LineLeapAdmin"
          ])
          .orderBy("name", "asc")
      )
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions.map(action => {
            var data = action.payload.doc.data();
            const id = action.payload.doc.id;
            return new User(data, id);
          });
        })
      );
  }

  get(id: string): Observable<User> {
    return this.collection
      .doc<User>(id)
      .snapshotChanges()
      .pipe(
        map(user => {
          var data = user.payload.data();
          const id = user.payload.id;
          return new User(data, id);
        })
      );
  }

  async getUserIdFromEmail(email: string): Promise<string> {
    let data = await this.collection.ref
      .limit(1)
      .where("email", "==", email)
      .get();
    return data.docs[0].id;
  }

  // getUserByEmail(email: string): Promise<

  getAll(): Observable<User[]> {
    return this.collection.snapshotChanges().pipe(
      map(actions => {
        return actions.map(action => {
          var data = action.payload.doc.data();
          const id = action.payload.doc.id;
          return new User(data, id);
        });
      })
    );
  }

  add(user: User): void {
    this.collection.add(user);
    return;
  }

  async updateDB(user: User): Promise<void> {
    let info = {
      admin: user.admin.toJSON(),
      name: user.name,
      email: user.email,
      phone_number: user.phone_number
    };
    await this.collection.doc(user.id).update(info);
    return;
  }

  async updateClaims(user: User): Promise<void> {
    const params = new HttpParams()
      .set("id", user.id)
      .set("type", user.admin.type.toString());
    await this.httpClient
      .get<JSON>(
        "https://us-central1-lineleap-e8561.cloudfunctions.net/changeUserAccess?",
        {
          params
        }
      )
      .toPromise();
    return;
  }
  async removeClaims(uid: string): Promise<void> {
    const params = new HttpParams().set("id", uid).set("type", "None");
    await this.httpClient
      .get<JSON>(
        "https://us-central1-lineleap-e8561.cloudfunctions.net/changeUserAccess?",
        {
          params
        }
      )
      .toPromise();
    return;
  }

  async createUser(info: {}): Promise<void> {
    let cities: string = info["admin"]["cities"].reduce(
      (str: string, cityRef: string) => (str += cityRef + ","),
      ""
    );
    let venues: string = info["admin"]["cities"].reduce(
      (str: string, venueRef: string) => (str += venueRef + ","),
      ""
    );
    const params = new HttpParams()
      .set("email", info["email"])
      .set("name", info["name"])
      .set("phone", info["phone"])
      .set("description", info["admin"]["description"])
      .set("cities", cities.substr(0, cities.length - 1))
      .set("venues", venues.substr(0, venues.length - 1))
      .set("type", info["admin"]["type"])
      .set("created_by", info["admin"]["created_by"])
      .set("edited_by", "");
    await this.httpClient
      .get<JSON>(
        "https://us-central1-lineleap-e8561.cloudfunctions.net/devCreateAdmin?",
        {
          params
        }
      )
      .toPromise();
  }

  delete(user: User): void {}
}
